(function () {
    // Garde-fou : ce fichier est concaténé dans dist/min.js ET enqueué séparément
    // (handle "carto-filter"). Sans ce verrou, la carte serait initialisée deux fois.
    if (window.HH_CARTO_READY) return;
    window.HH_CARTO_READY = true;

    // Registre des cartes Leaflet, indexé par numéro de bloc, pour la recherche de proximité
    var HH_CARTO = window.HH_CARTO = window.HH_CARTO || {};

    // TRADUCTIONS DES POPUPS (existant : indépendant de WPML String Translation)
    var mapTranslations = {
        'fr': { learnMore: 'En savoir +',   itinerary: 'Itinéraire',        scrollHint: 'Utilisez <kbd>Ctrl</kbd> + scroll pour zoomer' },
        'en': { learnMore: 'Learn more',    itinerary: 'Go there',          scrollHint: 'Use <kbd>Ctrl</kbd> + scroll to zoom' },
        'it': { learnMore: 'Scopri di più', itinerary: 'Come arrivarci',    scrollHint: 'Usa <kbd>Ctrl</kbd> + scroll per ingrandire' },
        'es': { learnMore: 'Saber más',     itinerary: 'Cómo llegar',       scrollHint: 'Usa <kbd>Ctrl</kbd> + scroll para hacer zoom' },
        'de': { learnMore: 'Mehr erfahren', itinerary: 'Dorthin gelangen',  scrollHint: '<kbd>Ctrl</kbd> + Scroll zum Zoomen verwenden' },
    };

    // ----------------------------------------------------------------------
    // OUTILS (i18n, distances, centrage)
    // ----------------------------------------------------------------------

    function hhLang() {
        return (document.documentElement.lang || 'fr').substring(0, 2);
    }

    function hhPopupT() {
        return mapTranslations[hhLang()] || mapTranslations['fr'];
    }

    // Libellé traduit (WPML String Translation via carto_ajax.i18n),
    // avec repli en français si carto_ajax n'est pas encore défini
    function hhT(key, fallback) {
        var i18n = (window.carto_ajax && carto_ajax.i18n) || {};
        return i18n[key] || fallback;
    }

    // Remplace le %s d'une chaîne traduite
    function hhFmt(str, value) {
        return String(str).replace('%s', value);
    }

    // Distance "à vol d'oiseau" entre deux points GPS, en kilomètres (haversine)
    function hhDistanceKm(lat1, lon1, lat2, lon2) {
        var R = 6371;
        var dLat = (lat2 - lat1) * Math.PI / 180;
        var dLon = (lon2 - lon1) * Math.PI / 180;
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    function hhFormatDistance(km) {
        if (km < 1) return Math.round(km * 1000) + ' m';
        if (km < 10) return (Math.round(km * 10) / 10).toLocaleString(hhLang()) + ' km';
        return Math.round(km) + ' km';
    }

    // Centre la carte sur un point en le plaçant à ~25% du bas de la carte,
    // pour laisser la place à la popup (qui s'ouvre vers le haut) sans déborder.
    function hhSetViewLowered(map, latlng, zoom) {
        var size = map.getSize();
        var point = map.project(latlng, zoom);
        // On remonte le centre de 25% de la hauteur => le point descend à 25% du bas
        var centerPoint = point.subtract([0, size.y * 0.25]);
        map.setView(map.unproject(centerPoint, zoom), zoom);
    }

    // ----------------------------------------------------------------------
    // GÉOCODAGE : Nominatim (OpenStreetMap) — couverture mondiale
    // Renvoie une Promise de {lat, lon, label} ou null si aucun résultat.
    // ----------------------------------------------------------------------
    var hhLastGeocodeAt = 0;

    function hhGeocode(q) {
        // Politique d'usage Nominatim : 1 requête par seconde maximum.
        var wait = Math.max(0, 1100 - (Date.now() - hhLastGeocodeAt));
        return new Promise(function (resolve) {
            setTimeout(resolve, wait);
        }).then(function () {
            hhLastGeocodeAt = Date.now();
            var url = 'https://nominatim.openstreetmap.org/search'
                + '?format=jsonv2&limit=1&addressdetails=1'
                + '&accept-language=' + encodeURIComponent(hhLang())
                + '&q=' + encodeURIComponent(q);
            return fetch(url, {headers: {'Accept': 'application/json'}});
        }).then(function (r) {
            return r.json();
        }).then(function (data) {
            if (!Array.isArray(data) || !data.length) return null;
            var place = data[0];
            var addr  = place.address || {};
            var ville = addr.city || addr.town || addr.village || addr.municipality
                || addr.county || addr.state || place.name || q;
            var pays  = addr.country || '';
            return {
                lat:   parseFloat(place.lat),
                lon:   parseFloat(place.lon),
                label: (pays && pays !== ville) ? (ville + ' (' + pays + ')') : ville
            };
        });
    }

    // ----------------------------------------------------------------------
    // PAGINATION DE LA LISTE (12 par page, numéros en fin de liste)
    // ----------------------------------------------------------------------
    var HH_PAGE_SIZE = 12;

    // Construit la suite de pages à afficher avec ellipses : 1 … 4 [5] 6 … 20
    function hhPageItems(current, totalPages) {
        var delta = 1;
        var range = [];
        var result = [];
        var last;
        for (var i = 1; i <= totalPages; i++) {
            if (i === 1 || i === totalPages || (i >= current - delta && i <= current + delta)) {
                range.push(i);
            }
        }
        for (var j = 0; j < range.length; j++) {
            var n = range[j];
            if (last) {
                if (n - last === 2) {
                    result.push(last + 1);
                } else if (n - last > 2) {
                    result.push('…');
                }
            }
            result.push(n);
            last = n;
        }
        return result;
    }

    function hhRenderPaginationNav($nav, current, totalPages) {
        if (totalPages <= 1) {
            $nav.empty().attr('hidden', true);
            return;
        }
        $nav.removeAttr('hidden');
        var html = '';
        html += '<button type="button" class="carto-pagination__btn carto-pagination__prev" data-page="' + (current - 1) + '"' + (current === 1 ? ' disabled' : '') + ' aria-label="' + hhT('page_precedente', 'Page précédente') + '">‹</button>';
        hhPageItems(current, totalPages).forEach(function (it) {
            if (it === '…') {
                html += '<span class="carto-pagination__dots">…</span>';
            } else {
                html += '<button type="button" class="carto-pagination__btn carto-pagination__num' + (it === current ? ' is-active' : '') + '" data-page="' + it + '"' + (it === current ? ' aria-current="page"' : '') + '>' + it + '</button>';
            }
        });
        html += '<button type="button" class="carto-pagination__btn carto-pagination__next" data-page="' + (current + 1) + '"' + (current === totalPages ? ' disabled' : '') + ' aria-label="' + hhT('page_suivante', 'Page suivante') + '">›</button>';
        $nav.html(html);
    }

    // Affiche la page demandée (12 tuiles) et (re)génère la navigation sous la liste
    function hhApplyPagination(blocId, page) {
        var $ = jQuery;
        var $liste = $('.liste_tiles[data-bloc="' + blocId + '"]');
        if (!$liste.length) return;
        var $nav = $liste.next('.carto-pagination');
        if (!$nav.length) {
            $nav = $('<nav class="carto-pagination" data-bloc="' + blocId + '" aria-label="' + hhT('pagination_label', 'Pagination des résultats') + '"></nav>');
            $liste.after($nav);
        }
        var $tiles = $liste.children('.tile_carto');
        var total = $tiles.length;
        var totalPages = Math.max(1, Math.ceil(total / HH_PAGE_SIZE));
        page = Math.min(Math.max(1, page || 1), totalPages);
        var start = (page - 1) * HH_PAGE_SIZE;
        var end = start + HH_PAGE_SIZE;
        $tiles.each(function (i) {
            if (i >= start && i < end) {
                this.classList.remove('is-paged-out');
            } else {
                this.classList.add('is-paged-out');
            }
        });
        hhRenderPaginationNav($nav, page, totalPages);
        $liste.data('currentPage', page);
    }

    // Changement de page au clic (délégué : survit aux re-render AJAX / recherche)
    jQuery(document).on('click', '.carto-pagination__btn', function () {
        var $ = jQuery;
        var $btn = $(this);
        if ($btn.is('[disabled]')) return;
        var $nav = $btn.closest('.carto-pagination');
        var blocId = String($nav.data('bloc'));
        var page = parseInt($btn.attr('data-page'), 10);
        if (isNaN(page)) return;
        hhApplyPagination(blocId, page);
        var $liste = $('.liste_tiles[data-bloc="' + blocId + '"]');
        if ($liste.length) {
            $('html, body').animate({scrollTop: $liste.offset().top - 100}, 250);
        }
    });

    // ----------------------------------------------------------------------
    // INITIALISATION DE LA CARTE + MARKERS
    // ----------------------------------------------------------------------
    jQuery(document).ready(function ($) {
        var t = hhPopupT();

        $('.carte').each(function () {
            var $carte = $(this);
            var mapId = $carte.attr('id');
            var blocId = mapId.replace('hh_dynamic_map_', '');
            // SETTINGS
            var default_lat  = 48.8;
            var default_lon  = 10.0;
            var default_zoom = 3;
            // INITIALISATION DE LA MAP
            var map = L.map(mapId, {zoomControl: true}).setView([default_lat, default_lon], default_zoom);
            L.tileLayer('https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
                maxZoom: 16,
                attribution: '© Esri'
            }).addTo(map);

            L.tileLayer('https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}', {
                maxZoom: 16,
                pane: 'shadowPane'
            }).addTo(map);

            map.on('movestart', function () {
                map.closePopup();
            });
            map.scrollWheelZoom.disable();
            map.boxZoom.disable();
            map.keyboard.disable();
            map.dragging.enable();
            map.touchZoom.enable();
            map.doubleClickZoom.enable();

            // CTRL + SCROLL ZOOM
            var $hint = $('<div class="map-scroll-hint">' + t.scrollHint + '</div>');
            $carte.parent().css('position', 'relative').append($hint);
            var hintTimeout;
            map.getContainer().addEventListener('wheel', function (e) {
                if (e.ctrlKey) {
                    e.preventDefault();
                    if (e.deltaY < 0) {
                        map.zoomIn();
                    } else {
                        map.zoomOut();
                    }
                } else {
                    $hint.addClass('visible');
                    clearTimeout(hintTimeout);
                    hintTimeout = setTimeout(function () {
                        $hint.removeClass('visible');
                    }, 1500);
                }
            }, {passive: false});

            // MARKERS & CLUSTER
            var markers = [];
            var markersById = {};
            var markerClusters = L.markerClusterGroup({
                iconCreateFunction: function (cluster) {
                    return L.divIcon({
                        html: '<div class="cluster-icon"><img src="/wp-content/themes/hh/src/img/mapmarker-empty.svg" /><span>' + cluster.getChildCount() + '</span></div>',
                        className: 'custom-cluster',
                        iconSize: [40, 40]
                    });
                }
            });
            // ICÔNES : tous les markers utilisent l'icône par défaut
            var SVGiconDefault = L.icon({iconUrl: '/wp-content/themes/hh/src/img/mapmarker.svg', iconSize: [32, 43], iconAnchor: [16, 43]});
            // CHARGEMENT DES MARKERS
            $carte.find('> .marker').each(function () {
                var $markerEl = $(this);
                var id     = $markerEl.data('id');
                var lat    = $markerEl.data('lat');
                var lng    = $markerEl.data('lng');
                var title  = $markerEl.data('title') || '';
                var texte  = $markerEl.data('texte') || '';
                var single = $markerEl.data('single');
                var link   = $markerEl.data('link') || '#';
                var flag   = $markerEl.data('flag') || '';

                if (lat && lng) {
                    var marker = L.marker([lat, lng], {icon: SVGiconDefault});
                    // Construction du bouton conditionnel
                    var buttonHTML = '';
                    if (single == 1 || single === true || single === "1" || single === "true") {
                        buttonHTML = '<a href="' + link + '" class="map-popup__btn" target="_blank" rel="noopener noreferrer">' + t.learnMore + '</a>';
                    }
                    // Lien itinéraire Google Maps
                    var gmapUrl = 'https://www.google.com/maps/dir/?api=1&destination=' + lat + ',' + lng;
                    // Drapeau
                    var flagHTML = flag ? '<img src="' + flag + '" class="map-popup__flag" alt="" />' : '';
                    // Construction popup
                    var popupHTML = '<div class="map-popup">' +
                        ((title || flagHTML) ? '<div class="map-popup__title">' + flagHTML + (title ? '<h3>' + title + '</h3>' : '') + '</div>' : '') +
                        (texte ? '<p>' + texte + '</p>' : '') +
                        '<a href="' + gmapUrl + '" class="map-popup__btn bouton map-popup__btn--itineraire" target="_blank" rel="noopener noreferrer">' + t.itinerary + '</a>' +
                        buttonHTML +
                        '</div>';
                    marker.bindPopup(popupHTML, {autoPan: false});
                    marker.off('click');

                    marker.on('click', function (e) {
                        var targetLatLng = e.latlng;

                        if (map.getCenter().equals(targetLatLng)) {
                            marker.openPopup();
                        } else {
                            map.once('moveend', function () {
                                marker.openPopup();
                            });
                            hhSetViewLowered(map, targetLatLng, map.getZoom());
                        }
                    });
                    markerClusters.addLayer(marker);
                    markers.push(marker);
                    if (id !== undefined && id !== null && id !== '') {
                        markersById[id] = marker;
                    }
                }
            });
            // AJOUT DU CLUSTER À LA MAP
            map.addLayer(markerClusters);
            // FORCER LA TAILLE (utile si la map était invisible au chargement)
            setTimeout(function () {
                map.invalidateSize();
            }, 300);
            // VUE GLOBALE
            map.setView([default_lat, default_lon], default_zoom);

            // Exposition pour la recherche de proximité
            HH_CARTO[blocId] = {
                map: map,
                clusters: markerClusters,
                markersById: markersById,
                defaultView: {lat: default_lat, lon: default_lon, zoom: default_zoom},
                searchPin: null
            };
        });
    });

    // ----------------------------------------------------------------------
    // RECHERCHE PAR PROXIMITÉ (ville ou pays)
    // ----------------------------------------------------------------------
    jQuery(document).ready(function ($) {
        $('.carto-search').each(function () {
            var $wrap  = $(this);
            var blocId = String($wrap.data('bloc'));
            var $form  = $wrap.find('.carto-search__form');
            var $input = $wrap.find('.carto-search__input');
            var $reset = $wrap.find('.carto-search__reset');
            var $msg   = $wrap.closest('.carto-controls').find('.carto-search__feedback');
            var $liste = $('.liste_tiles[data-bloc="' + blocId + '"]');
            // Liste complète (tous continents) telle que rendue au chargement
            var fullHtml = $liste.html();
            var pending  = false;

            function setMsg(text, isError) {
                $msg.text(text || '').toggleClass('is-error', !!isError);
            }

            function resetMapView() {
                var ctx = window.HH_CARTO && window.HH_CARTO[blocId];
                if (!ctx) return;
                if (ctx.searchPin) {
                    ctx.map.removeLayer(ctx.searchPin);
                    ctx.searchPin = null;
                }
                ctx.map.setView([ctx.defaultView.lat, ctx.defaultView.lon], ctx.defaultView.zoom);
            }

            function doReset() {
                $liste.html(fullHtml);
                $input.val('');
                setMsg('');
                $reset.attr('hidden', true);
                resetMapView();
                hhApplyPagination(blocId, 1);
            }

            // Trie les tuiles du plus proche au plus éloigné et renvoie la plus proche
            function sortByProximity(lat, lon) {
                // On repart toujours de la liste complète + on réinitialise le filtre continent
                $liste.html(fullHtml);
                var $contSelect = $('#carto-departement-filter[data-bloc="' + blocId + '"]');
                if (!$contSelect.length) $contSelect = $('#carto-departement-filter');
                $contSelect.val('');

                var tiles = $liste.children('.tile_carto').get();
                tiles.forEach(function (el) {
                    var $t = $(el);
                    var tLat = parseFloat($t.attr('data-lat'));
                    var tLng = parseFloat($t.attr('data-lng'));
                    var d = (isFinite(tLat) && isFinite(tLng)) ? hhDistanceKm(lat, lon, tLat, tLng) : Infinity;
                    $t.data('distance', d);
                    var $dist = $t.find('.tile_carto__distance');
                    if (isFinite(d)) {
                        $dist.text(hhFmt(hhT('distance', 'À %s'), hhFormatDistance(d))).removeAttr('hidden');
                    } else {
                        $dist.attr('hidden', true).text('');
                    }
                });
                tiles.sort(function (a, b) {
                    return $(a).data('distance') - $(b).data('distance');
                });
                $liste.append(tiles);
                $liste.find('.tile_carto').removeClass('is-nearest');
                var $nearest = $(tiles[0]);
                $nearest.addClass('is-nearest');
                // Affiche la 1re page (les plus proches)
                hhApplyPagination(blocId, 1);
                return $nearest;
            }

            // Centre la carte sur le point le plus proche (la card qui s'ouvre) et ouvre sa popup
            function focusMap(lat, lon, nearestId) {
                var ctx = window.HH_CARTO && window.HH_CARTO[blocId];
                if (!ctx) return;
                if (ctx.searchPin) {
                    ctx.map.removeLayer(ctx.searchPin);
                    ctx.searchPin = null;
                }
                ctx.searchPin = L.circleMarker([lat, lon], {
                    radius: 9, color: '#ffffff', weight: 2, fillColor: '#E30613', fillOpacity: 1
                }).addTo(ctx.map);

                var marker = (nearestId != null) ? ctx.markersById[nearestId] : null;

                if (marker && ctx.clusters && ctx.clusters.zoomToShowLayer) {
                    ctx.clusters.zoomToShowLayer(marker, function () {
                        ctx.map.once('moveend', function () {
                            marker.openPopup();
                        });
                        hhSetViewLowered(ctx.map, marker.getLatLng(), Math.max(ctx.map.getZoom(), 8));
                    });
                } else if (marker) {
                    ctx.map.once('moveend', function () {
                        marker.openPopup();
                    });
                    hhSetViewLowered(ctx.map, marker.getLatLng(), 8);
                } else {
                    ctx.map.setView([lat, lon], 6);
                }
            }            $form.on('submit', function (e) {
                e.preventDefault();
                if (pending) return;
                var q = ($input.val() || '').trim();
                if (!q) {
                    setMsg(hhT('saisir_lieu', 'Saisissez une ville ou un pays.'), true);
                    return;
                }
                pending = true;
                setMsg(hhT('recherche_en_cours', 'Recherche en cours…'), false);
                $liste.css('opacity', '0.4');

                hhGeocode(q)
                    .then(function (place) {
                        pending = false;
                        $liste.css('opacity', '1');
                        if (!place) {
                            setMsg(hhFmt(hhT('aucun_lieu', 'Aucun lieu trouvé pour « %s ».'), q), true);
                            return;
                        }
                        var $nearest = sortByProximity(place.lat, place.lon);
                        var nearestId = ($nearest && $nearest.length) ? $nearest.attr('data-id') : null;
                        focusMap(place.lat, place.lon, nearestId);
                        setMsg(hhFmt(hhT('plus_proches', 'Distributeurs les plus proches de %s'), place.label), false);
                        $reset.removeAttr('hidden');
                    })
                    .catch(function () {
                        pending = false;
                        $liste.css('opacity', '1');
                        setMsg(hhT('erreur_recherche', 'Erreur lors de la recherche. Réessayez.'), true);
                    });
            });

            $reset.on('click', function () {
                doReset();
            });
        });
    });

    // ----------------------------------------------------------------------
    // FILTRE PAR CONTINENT
    // ----------------------------------------------------------------------
    jQuery(document).ready(function ($) {
        $('#carto-departement-filter').on('change', function () {
            const continent = $(this).val();
            const $liste = $('.liste_tiles');
            // Feedback visuel pendant le chargement
            $liste.css('opacity', '0.4');
            $.ajax({
                url: carto_ajax.ajax_url,
                type: 'POST',
                data: {
                    action: 'carto_filter',
                    nonce: carto_ajax.nonce,
                    departement: continent
                },
                success: function (response) {
                    if (response.success) {
                        $liste.html(response.data.html).css('opacity', '1');
                        $liste.each(function () {
                            hhApplyPagination(String($(this).data('bloc')), 1);
                        });
                    }
                },
                error: function () {
                    $liste.css('opacity', '1');
                    console.error('Erreur lors du filtre carto.');
                }
            });
        });
    });

    // ----------------------------------------------------------------------
    // INITIALISATION DE LA PAGINATION (au chargement)
    // ----------------------------------------------------------------------
    jQuery(document).ready(function ($) {
        $('.liste_tiles').each(function () {
            hhApplyPagination(String($(this).data('bloc')), 1);
        });
    });
})();
